<template>
  <div>
    <carousel
      :scrollPerPage="true"
      :perPage="1"
      :paginationSize="20"
      :autoplay="true"
      :loop="true"
    >
      <slide v-for="(slide, id) in 3" :key="id">
        <img
          src="/assets/images/soyabean_big.png"
          width="100%"
          height="620px"
          style="width: 320px; height: 413px; object-fit: cover;"
          class="img-fluid mb-3 border border-dark"
        />
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide
  }
};
</script>
